import React, { useCallback } from 'react';
import { SearchProgress } from './SearchProgress';

interface SearchProgressScreenContentProps {
    isSearchProcessComplete: boolean;
    searchProgressInterval?: number;
    onProgress: React.Dispatch<React.SetStateAction<number>>;
}

interface SearchProgressScreenProps
    extends Pick<
        SearchProgressScreenContentProps,
        'onProgress' | 'searchProgressInterval'
    > {
    modalStep: number;
    isDownloadingTabs: boolean;
}

const SearchProgressScreenContent = ({
    isSearchProcessComplete,
    searchProgressInterval,
    onProgress,
}: SearchProgressScreenContentProps) => {
    const handleSearchProgressComplete = useCallback(() => {
        onProgress(2);
    }, [onProgress]);

    return (
        <SearchProgress
            onSearchProgressComplete={handleSearchProgressComplete}
            isSearchProgressComplete={isSearchProcessComplete}
            searchProgressInterval={searchProgressInterval}
        />
    );
};

export const SearchProgressScreen = ({
    modalStep,
    isDownloadingTabs,
    searchProgressInterval,
    onProgress,
}: SearchProgressScreenProps) => {
    if (!(modalStep === 1 || modalStep === 2) || isDownloadingTabs) {
        return null;
    }

    return (
        <SearchProgressScreenContent
            onProgress={onProgress}
            isSearchProcessComplete={modalStep === 2}
            searchProgressInterval={searchProgressInterval}
        />
    );
};
